import { render } from "./BookAnAppointment.vue?vue&type=template&id=5c7d7366"
import script from "./BookAnAppointment.vue?vue&type=script&lang=js"
export * from "./BookAnAppointment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__